import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['serviceUserDropdown', 'targetDropdown'];

  connect() {
    const serviceUser = this.serviceUserDropdownTargets.value;
    if (serviceUser) {
      const propertyId = this.element.dataset.propertyId;
      const selectedValue = this.targetDropdownTargets.dataset.selectedId
      this.makeCall(propertyId, serviceUser, selectedValue)
    }
  }

  updateTaskAssignments(event) {
    const propertyId = this.element.dataset.propertyId;
    const serviceUser = event.target.value;
    this.makeCall(propertyId, serviceUser)
  }

  refreshDropdownValues(data, selectedValue = null) {
    
      const selectBox = this.targetDropdownTarget;
      selectBox.innerHTML = '';
      selectBox.appendChild(document.createElement('option'));
    if (Array.isArray(data) && data.length != 0) {
      data.forEach(item => {
        const opt = document.createElement('option');
        opt.value = item.id;
        opt.innerHTML = item.name;
        if (selectedValue) {
          opt.selected = item.id === selectedValue
        }
        selectBox.appendChild(opt);
      });
    }
  }

  makeCall(propertyId, serviceUser, selectedValue = null) {
    Rails.ajax({
      type: 'GET',
      url: '/properties/' + propertyId + '/property_task_assignments/service_user_task_assignments',
      data: 'service_user=' + serviceUser,
      success: (data) => {
        this.refreshDropdownValues(data, selectedValue)
      }
    });
  }
}
